import { constants } from "../constants/index";

export function hasAppopriateContrast(fgColor: string, bgColor: string) {
  return (
    1 / calculateContrast(fgColor, bgColor) > constants.minimalContrastRatio
  );
}

// Implementation of https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-procedure algorithm
function calculateContrast(fgColor: string, bgColor: string) {
  const fgColorRgb = hexToRgb(fgColor);
  const bgColorRgb = hexToRgb(bgColor);

  const fgColorLuminance = calculateLuminance(
    fgColorRgb.r,
    fgColorRgb.g,
    fgColorRgb.b
  );
  const bgColorLuminance = calculateLuminance(
    bgColorRgb.r,
    bgColorRgb.g,
    bgColorRgb.b
  );

  return fgColorLuminance > bgColorLuminance
    ? (bgColorLuminance + 0.05) / (fgColorLuminance + 0.05)
    : (fgColorLuminance + 0.05) / (bgColorLuminance + 0.05);
}

function hexToRgb(hex: string) {
  if (hex.indexOf("#") === 0) {
    hex = hex.substring(1);
  }

  hex = hex.replace(constants.shorthandColorRegExp, (m, r, g, b) => {
    return r + r + g + g + b + b;
  });

  const rgb = parseInt(hex, 16);
  const r = (rgb >> 16) & 0xff;
  const g = (rgb >> 8) & 0xff;
  const b = (rgb >> 0) & 0xff;

  return { r, g, b };
}

function calculateLuminance(r: number, g: number, b: number) {
  const relativeRgb = [r, g, b].map((v) => {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  });

  return (
    relativeRgb[0] * 0.2126 + relativeRgb[1] * 0.7152 + relativeRgb[2] * 0.0722
  ); // according to ITU-R BT.709
}
